import { render, staticRenderFns } from "./InventarioItemBemPermanenteForm.vue?vue&type=template&id=331e8a45&scoped=true"
import script from "./InventarioItemBemPermanenteForm.vue?vue&type=script&lang=js"
export * from "./InventarioItemBemPermanenteForm.vue?vue&type=script&lang=js"
import style0 from "./InventarioItemBemPermanenteForm.vue?vue&type=style&index=0&id=331e8a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331e8a45",
  null
  
)

export default component.exports